import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { getMyTeam, joinTeam, leaveTeam } from '../web3/SFM-TeamsUtils';
import { useAccount } from 'wagmi';
import { toast } from 'react-hot-toast';
import Loader from './Loader/loader';
import ConfirmModal from './modals/ConfirmModal';
import { useTeam } from '../contexts/TeamContext';
function DropdownMenu(props) {
  const [options, setOptions] = React.useState();
  const [selectedOption, setSelectedOption] = React.useState();
  const [userTeam, setUserTeam] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isShowConfirmModal, setIsShowConfirmModal] = React.useState(false);

  const { address, isConnected } = useAccount();
  const { isTeamchanged } = useTeam();

  useEffect(() => {
    let selectOptions = [];
    props.options?.forEach((col) => {
      let singleoption = {
        value: col.value.toString(),
        label: (
          <div>
            <img
              alt="teams"
              className="border-radius-50"
              src={col.image}
              height="50px"
              width="50px"
            />
            &nbsp;{col.label}{' '}
          </div>
        ),
      };
      selectOptions.push({
        ...singleoption,
        requiresApproval: col.requiresApproval,
        leader: col.leader,
      });
    });
    setOptions(selectOptions);
  }, [props.options]);

  useEffect(() => {
    if (options && isConnected) {
      getUserTeam();
    }
  }, [options, isConnected, address, isTeamchanged]);
  const getUserTeam = React.useCallback(async () => {
    try {
      const team = await getMyTeam();
      if (team && options) {
        const myTeam = options.find((elem) => elem.value == team.id.toString());
        setSelectedOption(myTeam);
        setUserTeam(myTeam);
      } else {
        setSelectedOption(null);
      }
    } catch (e) {
      // Handle error
      setSelectedOption(null);
    }
  }, [options, address, isConnected, isTeamchanged]);

  const customStyles = {
    option: (styles, state) => ({
      ...styles,
      backgroundColor: state.isSelected ? '#00998f' : '#fff',
      color: '#000',
      '&:hover,&:focus,&:active': {
        backgroundColor: '#00998f',
        color: '#fff',
      },
    }),
    control: (baseStyles) => ({
      ...baseStyles,
      backgroundColor: 'transparent',
      color: '#fff',
      border: 'none',
      boxShadow: 'none',
      width: '250px',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#fff', // Custom colour
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  const requestJoinTeam = async (id) => {
    try {
      await joinTeam(parseInt(id))
        .then((e) => {
          setIsLoading(false);
          selectedOption.requiresApproval
            ? toast.success(
                `you request to join that team sent to team leader successfully`
              )
            : toast.success(`you joined team successfully`);
          window.location.reload();
        })
        .catch((err) => {
          userTeam ? setSelectedOption(userTeam) : setSelectedOption(null);
          if (err?.code == 'ACTION_REJECTED') {
            toast.error('You have canceled the transaction');
          } else {
            toast.error(err.reason ? err.reason : err.message);
          }
          setIsLoading(false);
        });
    } catch (e) {
      toast.error(e.message);
      setIsLoading(false);
    }
  };

  const handleChangeTeam = async () => {
    setIsShowConfirmModal(false);
    setIsLoading(true);
    if (userTeam) {
      try {
        await leaveTeam()
          .then(async (e) => {
            await requestJoinTeam(selectedOption.value);
          })
          .catch((e) => {
            userTeam ? setSelectedOption(userTeam) : setSelectedOption(null);
            if (e?.code == 'ACTION_REJECTED') {
              toast.error('You have canceled the transaction');
            } else {
              toast.error(e.message);
            }
            setIsLoading(false);
          });
      } catch (e) {
        if (e?.code == 'ACTION_REJECTED') {
          toast.error('You have canceled the transaction');
        } else {
          toast.error(e.message);
        }
        userTeam ? setSelectedOption(userTeam) : setSelectedOption(null);
        setIsLoading(false);
      }
    } else {
      await requestJoinTeam(selectedOption.value);
    }
  };

  return (
    <>
      {isLoading && (
        <div className="game-page-loader">
          <div className="game-spinner-body">
            <Loader />
          </div>
        </div>
      )}
      <Select
        options={options}
        onChange={(v) => {
          setSelectedOption(v);
          setIsShowConfirmModal(true);
        }}
        value={selectedOption}
        className="select-with-image"
        name="buywith"
        styles={customStyles}
        menuPortalTarget={document.body}
        components={{
          IndicatorSeparator: () => null,
        }}
        isLoading={props.loading}
        isDisabled={userTeam && address === userTeam.leader}
        placeholder="Solo"
      />
      {isShowConfirmModal && (
        <ConfirmModal
          show={isShowConfirmModal}
          handleCloseParent={() => {
            setIsShowConfirmModal(false);
            userTeam ? setSelectedOption(userTeam) : setSelectedOption(null);
          }}
          msg={
            userTeam
              ? 'Are you sure you want to change your team?'
              : 'Are you Sure you want to join this team?'
          }
          handleConfirm={() => handleChangeTeam()}
        />
      )}
    </>
  );
}

export default DropdownMenu;
